import { useLingui } from '@lingui/react/macro';
import { isToday } from 'date-fns';

interface Props {
  date: Date;
  practice: string;
  provider?: string;
}

export const AppointmentsGroupHeader = ({
  date,
  practice,
  provider,
}: Props) => {
  const { i18n, t } = useLingui();

  return (
    <div className="vai-p-2 vai-bg-slate-100">
      <div className="vai-flex vai-items-center vai-justify-between">
        <p className="vai-typography-h3">{practice}</p>
        <p className="vai-typography-large">
          {isToday(date) ? t`Today's Appointments ` : t`Appointments for `}
          {i18n.date(date, { weekday: 'long', month: 'long', day: 'numeric' })}
        </p>
      </div>
      {provider && (
        <p className="vai-typography-large" >
          {provider}
        </p>
      )}
    </div>
  );
};
